import { useCallback } from 'react';
import type { NavigateOptions, To } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { captureAsyncError } from '@/utils/captureAsyncError';

export function useAppNavigate() {
  const navigate = useNavigate();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      void Promise.resolve(navigate(to, options)).catch(captureAsyncError);
    },
    [navigate]
  );
}
